import { useMemo } from 'react';
import { BUYER_OPTIONS } from '@/features/shop-insurance';

interface Tab {
  value: string;
  label: string;
  dataTestId?: string;
}

interface UseTabConfigurationParams {
  hasPartnerWithDemographics: boolean;
  isMarriedOrPartnered: boolean;
  featureFlags?: FeatureFlags;
}

export function useTabConfiguration({
  hasPartnerWithDemographics,
  isMarriedOrPartnered,
  featureFlags,
}: UseTabConfigurationParams) {
  const policyTabs = useMemo((): Tab[] => {
    const tabs: Tab[] = [
      { value: 'single', label: 'Single Policy', dataTestId: 'shop-insurance-tabs-single' },
    ];

    if (isMarriedOrPartnered) {
      tabs.push({
        value: 'joint',
        label: 'Joint Policy',
        dataTestId: 'shop-insurance-tabs-joint',
      });
    }

    tabs.push({
      value: 'couples',
      label: 'Couples Discount',
      dataTestId: 'shop-insurance-tabs-couples',
    });
  

    return tabs;
  }, [isMarriedOrPartnered]);

  const buyerTabs = useMemo(
    (): Tab[] => [
      { value: '1-buyer', label: BUYER_OPTIONS['1-buyer'].label },
      { value: '2-buyer', label: BUYER_OPTIONS['2-buyer'].label },
    ],
    [],
  );

  return { policyTabs, buyerTabs };
}
